// extracted by mini-css-extract-plugin
export default {"item":"ModernizationShips_item","moreShips":"ModernizationShips_moreShips"};